import { Store, Module, ActionContext } from 'vuex';
import Ajax from '../../lib/ajax';
import FlightReservationOrder from '../entities/flight/reservation/flightReservationOrder';

class FlightPassengers {
  namespaced = true;
  state = {
    list: new Array(),
    loading: false,
    checkedPassengerList: new Array(),
  };

  actions = {
    getSelectedPassengerList({ commit }, payload) {
      commit('setSelectedPassengerList', payload);
    },
  };
  mutations = {
    setSelectedPassengerList(state, payload) {
      state.list = payload.data;
    },
    setCheckedPassengerList(state, payload) {
      state.checkedPassengerList = payload.data;
    },
  };
}

const flightPassengers = new FlightPassengers();
export default flightPassengers;
